window.__modules = window.__modules || [];

if (!window.__modules.includes('card-product--swatch.js')) {
  window.__modules.push('card-product--swatch.js');

  document.addEventListener('click', async (event) => {
    const target = event.target;
    const swatch = target.closest('.product-card-wrapper .option-swatch > a');
    if (!swatch) return;

    event.preventDefault();

    // Prevent reloading the same swatch
    if (swatch.parentElement.classList.contains('selected')) return;

    const productCard = swatch.closest('.product-card-wrapper');
    const disableScroll = productCard.classList.contains('disable-scroll');

    const url = new URL(swatch.href);
    // Set the view parameter to fetch the alternate template
    if (disableScroll) {
      url.searchParams.set('view', 'card-disable-scroll');
    } else {
      url.searchParams.set('view', 'card');
    }

    productCard.classList.add('loading'); // Add loading state

    try {
      // Fetch the new product card
      const response = await fetch(url.toString());
      const html = await response.text();

      const parser = new DOMParser();
      const newProductCard = parser.parseFromString(html, 'text/html').querySelector('.product-card-wrapper'); // Adjust selector if necessary

      if (newProductCard) {
        // Replace the old product card with the new one
        productCard.replaceWith(newProductCard);
        window.initWishlistOnProductRecommendations(newProductCard);
      } else {
        console.error('New product card not found in the fetched HTML.');
      }
    } catch (error) {
      console.error('Error fetching the new product card:', error);
    } finally {
      // Remove the loading state
      productCard.classList.remove('loading');
    }
  });
}
